import React from 'react';
import PropTypes from 'prop-types';
import {
  sortBy,
  filter,
} from 'lodash';
import {
  Grid,
  withStyles,
} from '@material-ui/core';
import StatusListItem from '../StatusListItem';
import styles from './styles';

export const StatusListComponent = ({
  statuses,
  includeArchived,
  classes,
}) => {
  const sortedStatuses = sortBy(filter(statuses, (status) => includeArchived || !status.archived), 'statusOrder');
  return (
    <Grid item xs={12} sm={10} md={8} lg={6} xl={4} className={classes.container}>
      <Grid
        container
        className={classes.timeline}
      >
        {
          sortedStatuses.map((status, index, mappedArray) => {
            const nextStatus = mappedArray[index + 1];
            const previousStatus = mappedArray[index - 1];
            return (
              <Grid item xs={12} className={classes.gridItem} key={status.id}>
                <StatusListItem
                  className={classes.item}
                  status={status}
                  nextStatus={nextStatus}
                  previousStatus={previousStatus}
                  index={index}
                />
              </Grid>
            );
          })
        }
      </Grid>
    </Grid>
  );
};

StatusListComponent.propTypes = {
  statuses: PropTypes.array,
  includeArchived: PropTypes.bool,
  classes: PropTypes.object,
};

StatusListComponent.defaultProps = {
  statuses: [],
  includeArchived: false,
  classes: {},
};

export default withStyles(styles)(StatusListComponent);
